import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ButtonTheme, IconPosition, NotificationScale, NotificationTheme } from '@fcom/ui-components';
import { ServiceCatalogService } from '@fcom/dapi/interfaces';
import { FinnairPassengerItem } from '@fcom/dapi/api/models';

import { NonSeatBundleAvailability } from '../../../../../store';

/**
 * One passenger's offer for an ancillary+ancillary (non-seat) bundle: the passenger name and
 * "Add combo" action, the bundle's constituent service cards and the passenger-specific price. When the
 * bundle isn't available for this passenger on this flight (`availability` null/unavailable), the
 * passenger is still listed but the offer is replaced by a short "not available" notice.
 */
@Component({
  selector: 'fin-bundle-offer-card',
  templateUrl: './bundle-offer-card.component.html',
  styleUrls: ['./bundle-offer-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BundleOfferCardComponent {
  readonly constituents = input.required<ServiceCatalogService[]>();
  readonly passenger = input.required<FinnairPassengerItem>();
  readonly availability = input.required<NonSeatBundleAvailability | null>();
  readonly selectedForPassenger = input.required<boolean>();

  @Output() addCombo = new EventEmitter<void>();
  @Output() removeCombo = new EventEmitter<void>();

  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly NotificationTheme = NotificationTheme;
  readonly NotificationScale = NotificationScale;

  readonly passengerName = computed(() =>
    [this.passenger()?.firstName, this.passenger()?.lastName].filter(Boolean).join(' ')
  );
}
